package org.lennycodes.hldi.styles
import com.varabyte.kobweb.compose.css.BorderCollapse
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderCollapse
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme
val VolunteerButtonStyle = CssStyle {

    base {
        Modifier

            .backgroundColor(HLDITheme.Colors.white)
            .color(HLDITheme.Colors.primary)
            .borderRadius(8.px)
            .fontSize(16.px)
            .fontWeight(600)
            .textDecorationLine(TextDecorationLine.None)
            .transition(
                Transition.of(
                    property = "all",
                    duration = 300.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            .styleModifier {
                property("transform", "translateY(-2px)")
                property("box-shadow", "0 4px 12px rgba(0,0,0,0.2)")
            }
    }

}
val OutlineButtonStyle = CssStyle {

    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.tranparent)
            .color(HLDITheme.Colors.white)
            .borderRadius(8.px)
            .fontSize(16.px)
            .fontWeight(FontWeight.SemiBold)
            .textDecorationLine(TextDecorationLine.None)
            .border(
                2.px,
                LineStyle.Solid,
                color = HLDITheme.Colors.white
            )
            .transition(
                Transition.of(
                    property = "all",
                    duration = 300.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            .styleModifier {

                property(
                    "background-color",
                    "rgba(255,255,255,0.1)"
                )

                property(
                    "transform",
                    "translateY(-2px)"
                )

                property(
                    "box-shadow",
                    "0 4px 12px rgba(0,0,0,0.2)"
                )

            }
    }

}